import { Component, h, Prop } from "@stencil/core";

/**
 * @slot image - Preview image of the download
 * @slot title - Title of the download
 * @slot description - Description of the download
 */
@Component({
    tag: "ux-iws-teaser-download-tile",
    styleUrl: "teaser-download-tile.scss",
})
export class TeaserDownloadTile {
    private baseClass = "ux-iws-teaser-download-tile";

    /** Optional comma-separated list of tags. For each tag, a corresponding `<ux-tag>` element is rendered */
    @Prop() readonly tags: string = "";

    /** If a file name is provided, the link acts as direct download  */
    @Prop() readonly download: string = "";

    /** Additional file info of the download (example: "20/01/2025 PDF – 460 KB") */
    @Prop() readonly fileInfo: string = "";

    /** Link of the teaser  */
    @Prop() readonly link: string = "";

    /** Aria label of the link element */
    @Prop() readonly linkText: string = "Download";

    /** Maximum number of text lines of the content */
    @Prop() readonly textLines: number = 4;

    render() {
        return (
            <ux-iws-link-wrapper class={this.baseClass}>
                <div class={`${this.baseClass}__inner`}>
                    <div class={`${this.baseClass}__image`}>
                        <slot name="image" />
                    </div>
                    <div class={`${this.baseClass}__content`}>
                        {(this.tags || this.fileInfo) && (
                            <div class={`${this.baseClass}__header`}>
                                {this.tags &&
                                    this.tags
                                        .split(",")
                                        .map((tag) => tag.trim())
                                        .map((tag) => (
                                            <ux-tag key={tag} disabled={true}>
                                                {tag}
                                            </ux-tag>
                                        ))}
                                {this.fileInfo && (
                                    <div class={`${this.baseClass}__info`}>
                                        {this.fileInfo}
                                    </div>
                                )}
                            </div>
                        )}
                        <ux-text-lines-limit text-lines={this.textLines}>
                            <div class={`${this.baseClass}__description`}>
                                <slot name="title" />
                                <slot name="description" />
                            </div>
                        </ux-text-lines-limit>
                        <div class={`${this.baseClass}__actions`}>
                            <a
                                class="ux-button ux-button--icon-only"
                                data-testid="download"
                                href={this.link}
                                download={this.download ? this.download : null}
                                target={this.download ? "_blank" : null}
                                rel="noopener noreferrer"
                                aria-label={this.linkText}
                            >
                                <ux-icon
                                    name={
                                        this.download
                                            ? "download"
                                            : "chevron-right"
                                    }
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </ux-iws-link-wrapper>
        );
    }
}
